import { createSelector } from 'reselect'

const mcqActivitySelector = createSelector(
	[
		state => state.creationTool.mcq,
	],
	mcqData => mcqData
)

export default mcqActivitySelector
